module.exports = __webpack_public_path__ + "static/media/KennonDT.2d90bbd9.mp4";